import { Locale, format as formatDate, isDate, isValid } from 'date-fns';
import { enGB as en, pl } from 'date-fns/locale';
import i18n from 'i18next';
import { EBitrateBitsMultiple, convertBitrates } from '../helpers';
import translationEn from './resources/en.json';
import translationPl from './resources/pl.json';

const dateLocales: Record<string, Locale> = { en, pl };
const defaultLocale = 'en';
const commonNs = 'common';
const resources = {
  en: { [commonNs]: translationEn },
  pl: { [commonNs]: translationPl },
} as const;

i18n.init({
  fallbackLng: defaultLocale,
  lng: defaultLocale,
  ns: commonNs,
  fallbackNS: commonNs,
  debug: true,
  interpolation: {
    escapeValue: false, // not needed for react!!
    skipOnVariables: false,
    format: (value: Date | number | string, format = 'Pp', lng = defaultLocale): string => {
      if (isDate(value) && isValid(value)) {
        const locale = dateLocales[lng];
        return formatDate(value as Date, format, { locale });
      }
      if (format === 'kilobit-per-second')
        return `${convertBitrates(value as number, EBitrateBitsMultiple.kilobitPerSecond, 'divide')} kb/s`;
      if (format === 'megabit-per-second')
        return `${convertBitrates(value as number, EBitrateBitsMultiple.megabitPerSecond, 'divide')} Mb/s`;
      if (format === 'hexadecimal') return `0x${(value as number).toString(16)}`;

      return value as string;
    },
  },
  resources,
});

export default i18n;
